import type { PrimitiveButtonVariant } from './Button.helpers';

export const BUTTON_HUMAN_LOADING = 400;

export const ERROR_ANIMATION_DURATION = 400;

export const FILLED_BUTTON_VARIANTS: readonly PrimitiveButtonVariant[] = [
  'default',
  'destructive',
  'success',
  'warning',
  'secondary',
];

export const DANGER_BUTTON_VARIANTS: readonly PrimitiveButtonVariant[] = [
  'outline-destructive',
  'ghost-destructive',
];

export const SUCCESS_BUTTON_VARIANTS: readonly PrimitiveButtonVariant[] = [
  'outline-success',
];

export const WARNING_BUTTON_VARIANTS: readonly PrimitiveButtonVariant[] = [
  'outline-warning',
];
